// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"a7ffc627","278":"6ebc41bb","359":"3b9dfc86","896":"8216bbe5"}[chunkId] + ".chunk.js";
};